import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

const getColor = (
  isActive: boolean,
  hover: boolean,
  darkMode: boolean
): string => {
  if (isActive) {
    return darkMode ? themeStyle.darkInkMain : themeStyle.varInkMain;
  }

  if (hover) {
    return darkMode ? themeStyle.darkInkMedium : themeStyle.varInkMedium;
  }

  return darkMode
    ? themeStyle.darkInkLightMedium
    : themeStyle.varInkLightMedium;
};

export const StepContainer = styled(FlexColumn)<{
  isActive: boolean;
  darkMode: boolean;
}>`
  position: relative;
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
  gap: 12px;

  color: ${({ isActive, darkMode }) => getColor(isActive, false, darkMode)};

  &:hover > * {
    color: ${({ isActive, darkMode }) => getColor(isActive, true, darkMode)};
  }
`;

export const BarWrapper = styled.div<{ isActive: boolean }>`
  display: none;
  height: 100%;

  position: absolute;
  top: 0;
  left: -24px;

  ${QUERIES.largeTabletAndUp} {
    display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  }
`;
